import React from 'react';
import MerchantAccountIcon from '../../../../../images/sidebar/merchant-accounts-icon-blue.svg';
import { CustomLabel, FlexContainer } from '@mindmemobile/mm-shared-global';

type Props = {
    name: string;
};
const RenderMerchantAccountName: React.FC<Props> = ({ name }) => {
    return (
        <FlexContainer spacing={12}>
            <img src={MerchantAccountIcon} />
            <CustomLabel>{name}</CustomLabel>
        </FlexContainer>
    );
};

export default RenderMerchantAccountName;
